/** Security scheme names the per-partner OpenAPI documents declare and the dashboard prefills. */
export const PARTNER_TOKEN_SECURITY_SCHEME = 'partnerToken';
export const TENANT_HEADER_SECURITY_SCHEME = 'tenantHeader';
export const TENANT_HEADER = 'reach-tenant-id';
//# sourceMappingURL=partner-openapi.js.map